/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/Billing/Broadcasting/Enums/SubscriptionEvent.php */
export const subscriptionEvent = {
	Changed: 'changed',
} as const

/** @see backend/nexus/modules/Billing/Broadcasting/Enums/SubscriptionEvent.php */
export type SubscriptionEvent = (typeof subscriptionEvent)[keyof typeof subscriptionEvent]
